import React, { useEffect, useRef } from 'react';
import './ContactDialog.css';

// Contact information constants
const CONTACT_INFO = {
  telegram: {
    url: 'https://t.me/daniil_zhestovskiy',
    label: 'Telegram',
    icon: 'fab fa-telegram',
    className: 'telegram'
  },
  whatsapp: {
    url: 'https://api.whatsapp.com/send?phone=79214104770&text=%D0%9F%D1%80%D0%B8%D0%B2%D0%B5%D1%82!%20%D0%90%20%D0%BC%D0%BE%D0%B6%D0%BD%D0%BE%20%D0%BA%20%D1%82%D0%B5%D0%B1%D0%B5%20%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D0%B0%D1%82%D1%8C%D1%81%D1%8F?',
    label: 'WhatsApp',
    icon: 'fab fa-whatsapp',
    className: 'whatsapp'
  }
};

function ContactDialog({ open, onClose }) {
  // const [formData, setFormData] = useState({
  //   name: '',
  //   email: '',
  //   phone: '',
  //   message: ''
  // });
  
  const dialogRef = useRef(null);

  
  // Handle click outside the dialog
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dialogRef.current && !dialogRef.current.contains(event.target)) {
        onClose(null);
      }
    };
    
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
      // Prevent scrolling when dialog is open
      document.body.style.overflow = 'hidden';
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      // Restore scrolling when dialog is closed
      document.body.style.overflow = 'auto';
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="dialog-overlay">
      <div className="dialog-content" ref={dialogRef}>
        <button className="dialog-close" onClick={() => onClose(null)} aria-label="Закрыть">
          <i className="fas fa-times"></i>
        </button>
        <h2 className="dialog-title">Связаться с нами</h2>
        <div className="contact-links">
          {Object.values(CONTACT_INFO).map((contact) => (
            <a 
              key={contact.className}
              href={contact.url}
              target="_blank" 
              rel="noopener noreferrer" 
              className={`contact-link ${contact.className}`}
            >
              <i className={contact.icon}></i>
              <span>{contact.label}</span>
            </a>
          ))}
        </div>
        {/* Commented out form for now
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="name">Ваше имя</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="form-control"
              placeholder="Введите ваше имя"
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="form-control"
              placeholder="Введите ваш email"
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Телефон</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              className="form-control"
              placeholder="Введите ваш телефон"
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Сообщение</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              className="form-control"
              placeholder="Введите ваше сообщение"
              rows="4"
            ></textarea>
          </div>
          <button type="submit" className="btn btn-primary">Отправить</button>
        </form>
        */}
      </div>
    </div>
  );
}

export default ContactDialog; 